import React, { useState } from 'react';
import { openPaymentSettingsPortal, handlePayment } from '../redux/actions/paymentActions';
import { useSelector } from 'react-redux';
import "../styles/style.css"

const staticPlans = [
  {
    name: 'Monthly',
    price: process.env.REACT_APP_MONTHLY_PLAN_PRICE,
    features: [
      "Unlock 1000 credits monthly",
      "Explore our Product Database",
      "Access Editors' Choice content",
      "Utilize the AI Copy Creator for your projects",
    ],
    popular: false,
    plan: 'Monthly',
  },
  {
    name: 'Annual',
    price: process.env.REACT_APP_ANNUAL_PLAN_PRICE,
    features: [
      "Enjoy 12000 credits annually",
      "Explore our Product Database",
      "Access Editors' Choice content",
      "Utilize the AI Copy Creator for your projects",
      "Benefit from unlimited support throughout the year"
    ],
    popular: true,
    plan: 'Annual',
  },
  // {
  //   name: 'Premium',
  //   price: process.env.REACT_APP_PREMIUM_PLAN_PRICE,
  //   features: [
  //     "Enjoy 12000 credits annually",
  //     "You will get 4000 CREDITS",
  //     "Access Editors' Choice content",
  //     "Utilize the AI Copy Creator for your projects",
  //   ],
  //   popular: false,
  //   plan: 'Premium',
  // },
];

const Settings = () => {
  const [loading, setLoading] = useState(null);
  const [paymentPortalLoading, setPaymentPortalLoading] = useState(false);
  const currentPlan = useSelector((state) => state.stripe.currentPlan);

  const user = useSelector((state) => state.auth.user);

  const buyPlan = async (plan) => {
    try {
      if (user && user.paymentStatus === 'lifetime') {
        return;
      }
      setLoading(plan);
      await handlePayment(plan);
    } catch (err) {
      console.log("Something went wrong in buying plan");
      console.log(err);
    } finally {
      setLoading(null);
    }
  };

  const onPaymentSettings = () => {
    if (paymentPortalLoading) return;
    setPaymentPortalLoading(true);
    openPaymentSettingsPortal({
      setLoading: () => setPaymentPortalLoading(false),
      returnPath: "/settings",
    });
  };

const isMobileScreen = window.innerWidth < 768;

  return (
    <div style={isMobileScreen ? {
      width: "100vw"
    } : {}}>
      <div
        className={`${isMobileScreen ? "px-7" : "px-12"} fade-in py-4 flex w-full justify-between items-center gap-3 font-Inter`}
      >
        <p className="title">Payment Plans</p>
        <button
          type="button"
          disabled={paymentPortalLoading}
          onClick={onPaymentSettings}
          className="inline-flex shrink-0 items-center gap-x-2 text-sm font-semibold font-Inter px-4 rounded-lg bg-primary text-white py-2 hover:opacity-90 disabled:opacity-60"
        >
          {paymentPortalLoading ? "Opening…" : "Payment settings"}
        </button>
      </div>
      <hr className="bg-gray-200 h-[1.15px] mt-1" />
      <div className="py-4 w-full min-h-screen overflow-hidden">
        <p className={`${isMobileScreen ? "px-7" : "px-12"} text-sm text-[#475467] max-w-2xl`}>
          Payment settings opens Stripe’s customer portal to view invoices, update your payment method, or cancel your subscription.
        </p>

        <section className="text-gray-600 body-font overflow-hidden mt-2">
          <div className="container px-8 mx-auto">
            <div className="flex flex-wrap -m-4">
              {staticPlans.map((item, key) => (
                <div key={key} className="p-4 xl:w-1/4 md:w-1/2 w-full">
                  <div className="h-full p-6 relative rounded-lg border-[1px] flex flex-col overflow-hidden">
                    {item.popular && (
                      <span className="bg-primary border-primary text-white px-3 py-1 tracking-widest text-xs absolute right-0 top-0 rounded-bl">
                        POPULAR
                      </span>
                    )}
                    <h2 className="text-sm tracking-widest title-font mb-1 font-medium text-Inter">
                      {item.name} Plan
                    </h2>
                    <h1 className="text-5xl text-gray-900 leading-none flex items-center text-Inter pb-4 mb-4 border-b border-gray-200">
                      <span>${item.price}</span>
                      <span className="text-lg ml-1 font-normal text-gray-500 text-Inter">/mo</span>
                    </h1>

                    <div className="mt-2.5 space-y-3 mb-4">
                      {item.features.map((feature, key) => (
                        <p key={key} className="flex items-center text-gray-600 text-Inter">
                          <span className="w-4 h-4 mr-2 inline-flex items-center justify-center bg-orange-100 text-white rounded-full flex-shrink-0">
                            {/* Your SVG icon here */}
                          </span>
                          {feature}
                        </p>
                      ))}
                    </div>
                    {console.log(loading, item.plan, currentPlan)}
                    {loading === item.plan ? (
                      <button
                        disabled
                        type="button"
                        className="mx-auto mt-4 text-primary text-Inter border-primary border-[1px] py-2 px-4 w-full font-semibold focus:outline-none hover:bg-priborder-primary rounded"
                      >
                        {/* Your loading animation here */}
                        Loading...
                      </button>
                    ) : currentPlan === item.plan ? (
                      <button
                        className="mt-auto font-semibold font-Inter text-sm block w-full rounded-lg transition mx-auto duration-200 ease-in bg-primary hover:bg-primary py-2.5 text-white"
                      >
                        Current Plan
                      </button>
                    ) : (
                      < button
                        disabled={loading !== null}
                    onClick={() => buyPlan(item.plan)}
                    className={`mt-auto mx-auto text-primary text-Inter border-primary border-[1px] py-2 px-4 w-full font-semibold focus:outline-none hover:bg-priborder-primary rounded`}
                      >
                    Buy
                  </button>
                    )}
                </div>
                </div>
              ))}
          </div>
      </div>
    </section >
      </div >
    </div>
  );
};

export default Settings;
